import DrawStatus from '../draw-staus/draw-status';
import React, {ReactNode} from 'react';
import LazyImage from '@/components/basic/image';
import {useTranslation} from 'react-i18next';
import theme from '@/style';
import WonResult from '../won/won';
import {DATA_MAP} from '../draw-staus';
import {toPriceStr} from '@utils';
import ShareButton from './share-btn';

export interface DetailCardProps {
  status: 1 | 0 | 2 | 3 | 4;
  id?: string;
  amount?: number;
  rightEle?: React.ReactElement | null;
  name?: string;
  awardNumber?: number;
  tip?: string | React.ReactElement;
  result?: string | React.ReactElement;
  betTime?: string;
  gameLogo: string | number;
  canGoDetail?: boolean;
  hasResult?: boolean;
  hasResultTip?: boolean;
  betResult?: ReactNode;
  onCopy?: () => void;
  onPress?: () => void;
  hasShare?: boolean;
  onShare?: () => void;
  hasAward?: boolean;
}

const DetailCard = ({
  canGoDetail = false,
  gameLogo,
  name,
  tip,
  rightEle,
  amount = 0,
  status = 0,
  awardNumber = 0,
  hasResultTip = true,
  betTime,
  hasResult,
  result,
  betResult,
  onCopy,
  onPress,
  id,
  hasShare = false,
  onShare,
  hasAward = false,
}: DetailCardProps) => {
  const {i18n} = useTranslation();
  const Wrap = canGoDetail ? 'button' : 'div';

  return (
    <Wrap
      type={canGoDetail ? 'button' : undefined}
      onClick={canGoDetail ? onPress : undefined}
      className="block w-full border-0 bg-transparent p-0 text-left">
      <DrawStatus
        colors={DATA_MAP[status].bg}
        textColor={DATA_MAP[status].color}
        label={i18n.t(`bets-page.status.${DATA_MAP[status].text}`)}
        isDetail
        id={id}
        onCopy={onCopy}
      />
      <div className="mt-3 flex items-center justify-between">
        <div className="flex min-w-0 flex-1 items-center">
          <div className="h-12 w-12 shrink-0 overflow-hidden rounded-lg">
            <LazyImage
              imageUrl={gameLogo}
              width={48}
              height={48}
              occupancy="transparent"
            />
          </div>
          <div className="mx-3 min-w-0 flex-1">
            <span
              className="block truncate font-InterBold text-base"
              style={{color: theme.basicColor.dark}}>
              {name}
            </span>
            {React.isValidElement(tip) ? (
              tip
            ) : (
              <span className="text-sm">{tip}</span>
            )}
          </div>
        </div>
        {rightEle ? (
          rightEle
        ) : (
          <div className="text-right">
            <span className="block text-sm font-medium">
              {i18n.t('label.payment')}
            </span>
            <span className="block font-InterBold text-base">
              {toPriceStr(amount)}
            </span>
          </div>
        )}
      </div>
      <div className="my-3 h-px bg-[#D8E0EA]" />
      <div className="flex justify-between">
        <span
          className="text-sm font-medium"
          style={{color: theme.fontColor.accent}}>
          {i18n.t('bets-page.label.bettingTime')}
        </span>
        <span className="text-sm font-medium">{betTime}</span>
      </div>
      {hasResult ? (
        <div className="mt-3 flex justify-between">
          <span
            className="text-sm font-medium"
            style={{color: theme.fontColor.accent}}>
            Result
          </span>
          {React.isValidElement(result) ? (
            result
          ) : (
            <span className="text-sm font-medium">{result}</span>
          )}
        </div>
      ) : null}
      {hasShare ? (
        <div className="mt-3 flex items-center justify-between">
          <span
            className="text-sm font-medium"
            style={{color: theme.fontColor.accent}}>
            Share
          </span>
          <ShareButton onShare={onShare} hasAward={hasAward} />
        </div>
      ) : null}
      {betResult}
      {(status === 1 || status === 4) && awardNumber > 0 && hasResultTip ? (
        <WonResult awardAmount={awardNumber} />
      ) : null}
      {(status === 0 || (status === 4 && awardNumber === 0)) && hasResultTip ? (
        <div className="pt-3 text-center text-[0.9375rem] text-primary">
          {i18n.t('game-page.label.guessWrong')}
        </div>
      ) : null}
      {status === 3 && hasResultTip ? (
        <div className="pt-3 text-center text-[0.9375rem] text-primary">
          {i18n.t('game-page.label.ticketSetting')}
        </div>
      ) : null}
    </Wrap>
  );
};

export default DetailCard;
